import { Expose, Type } from "class-transformer";

import { PgaPolicy } from "src/shared/models/pga-policy.model";
import { VehicleOffer } from "src/shared/models/vehicle-offer.model";
import { VehicleTracking } from "src/shared/models/vehicle-tracking.model";
import { Vehicle } from "src/shared/models/vehicle.model";

export class VehiclePolicy extends PgaPolicy {
    @Expose()
    @Type(() => VehicleOffer)
    offer: VehicleOffer = new VehicleOffer();
    @Expose() status = "";
    @Expose()
    @Type(() => VehicleTracking)
    tracking?: VehicleTracking;
    @Expose()
    @Type(() => Vehicle)
    vehicle?: Vehicle;
}
